<template>
  <div class="leads-widget">
    <div class="leads-wrapper">
      <div class="loader" ref="loader" v-show="showLoading"></div>

      <!-- Start of Leads item -->
      <div class="card-widget" v-if="lead.id">
        <div class="assignments-item-header">
          <div class="assignments-item-brand">
            <img
              v-if="$hasKey(lead, 'user.customer_profile.logo')"
              @click.prevent="
                $router.push({
                  name: 'profile_customer',
                  params: { id: lead.user_id | validate },
                })
              "
              :src="
                $fullUrl('images/profiles/' + lead.user.customer_profile.logo)
              "
            />
            <img
              v-else-if="$hasKey(lead, 'user.company_profile.logo')"
              @click.prevent="
                $router.push({
                  name: 'profile_customer',
                  params: { id: lead.user_id | validate },
                })
              "
              :src="
                $fullUrl('images/profiles/' + lead.user.company_profile.logo)
              "
            />
            <img
              v-else
              @click.prevent="
                $router.push({
                  name: 'profile_customer',
                  params: { id: lead.user_id | validate },
                })
              "
              src="@/assets/icons/logo_avatar.svg"
            />

            <div class="content">
              <div class="title">
                <label v-if="$hasKey(lead, 'user.company_profile.name')">{{
                  lead.user.company_profile.name | validate
                }}</label>
                <label v-else>{{ lead.customer | validate }}</label>
                <span class="date">{{
                  lead.due_date_from | formatDate | validate
                }}</span>
              </div>
              <div class="options">
                <button
                  class="share-btn-transparent"
                  @click="show_share = true"
                >
                  Share
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="assignments-item-body">
          <h4>{{ lead.title | validate }}</h4>
          <img
            :src="$fullUrl('images/profiles/' + lead.cover_photo)"
            v-if="lead.cover_photo"
          />
          <p v-readMore:200="lead.description"></p>
          <label>Skills</label>
          <div class="skills-widget">
            <div
              class="skill-item"
              v-for="(skill, i) in lead.skills"
              :key="i + 'skills'"
            >
              {{ skill | validate }}
            </div>
          </div>
          <button
            class="btn-more-skills"
            v-if="!lead.more_skills && lead.all_skills > lead.less_skills"
            @click="(lead.skills = lead.all_skills), (lead.more_skills = true)"
          >
            <u>More skills</u>
          </button>
          <button
            class="btn-more-skills"
            v-if="lead.more_skills && lead.all_skills > lead.less_skills"
            @click="
              (lead.skills = lead.less_skills), (lead.more_skills = false)
            "
          >
            <u>Less skills</u>
          </button>
          <div class="assignments-info">
            <div class="col-one">
              <div class="content" v-if="lead.roles">
                <label>Role</label>
                <p>{{ lead.roles | validate }}</p>
              </div>
              <div class="content" v-if="lead.address">
                <label>Location</label>
                <p>{{ lead.address | validate }}</p>
              </div>
              <div class="content" v-if="lead.due_date_from">
                <label>Start Date</label>
                <p>
                  {{ lead.due_date_from | formatDate | validate }}
                  <template v-if="lead.is_urgent"
                    >/ As soon as possible</template
                  >
                </p>
              </div>
            </div>
            <div class="col-two">
              <div class="content" v-if="lead.duration">
                <label>Duration</label>
                <p>{{ lead.duration | validate }}</p>
              </div>
              <div class="content" v-if="lead.workload">
                <label>Work Load</label>
                <p>{{ lead.workload | validate }}</p>
              </div>
              <div class="content" v-if="lead.rate">
                <label>Rate</label>
                <p>
                  {{ lead.rate | validate }}
                  <template v-if="lead.is_negotiable">/ Negotiable</template>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Leads item -->
      <div v-show="!showLoading" class="empty-assignment" v-else>
        Assignment not found
      </div>
    </div>

    <div class="floater">
      <chat :stranger="newChat" v-if="access_token"></chat>
    </div>

    <share-helper
      v-if="show_share"
      @onClose="show_share = false"
      :title="lead.title"
      description
    />
  </div>
</template>

<script>
import { eventBus } from "@/main";
import axios from "axios";
import { API_BASE_URL, GET_ALL_ASSIGNMENT_URL } from "@/Store/variable";
import { mapGetters } from "vuex";
import Loading from "@/components/Loader/Loading";
import lottie from "lottie-web";
import * as animationData from "@/assets/json/loader";
import Chat from "@/components/Chat/Chat";
export default {
  name: "Leads",
  components: {
    Loading,
    Chat,
  },
  computed: {},
  props: {},
  data: () => {
    return {
      show_share: false,
      anim: null,
      showLoading: false,
      lead: {},
      newChat: {},
      access_token: null,
    };
  },
  mounted() {
    let vm = this;
    vm.access_token = sessionStorage.authToken;
    vm.anim = lottie.loadAnimation({
      container: this.$refs.loader,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    });
    if (vm.$route.params.name) {
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getAssignment(id);
    }
  },
  methods: {
    getAssignment(id) {
      let vm = this;
      vm.showLoading = true;
      vm.$store
        .dispatch("CONSULTANT_GET_ASSIGNMENT", { id: id })
        .then((value) => {
          vm.showLoading = false;
          let item = value.data;
          let roles = item.role;
          let skills = [];
          let loc = "";
          if (item.user) {
            if (item.user.customer_profile)
              eventBus.$set(item, "customer", item.user.customer_profile.name);
            else eventBus.$set(item, "customer", item.user.username);
          } else eventBus.$set(item, "customer", "");

          eventBus.$set(item, "address", item.address);

          eventBus.$set(item, "more_skills", false);

          item.skills.forEach((skill) => {
            skill.roles.forEach((i) => {
              skills.push(i.name);
            });
            skill.tools.forEach((i) => {
              skills.push(i.name);
            });
            skill.domains.forEach((i) => {
              skills.push(i.name);
            });
            skill.competences.forEach((i) => {
              skills.push(i.name);
            });
            skill.languages.forEach((i) => {
              skills.push(i.name);
            });
          });
          item.roles = roles;
          eventBus.$set(item, "all_skills", skills);
          eventBus.$set(item, "less_skills", skills.slice(0, 3));
          item.skills = item.less_skills;
          vm.lead = item;
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
  },
  watch: {
    "$route.params.name"(name) {
      let vm = this;
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getAssignment(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.leads-widget {
  display: flex;
  justify-content: center;
  padding-top: 80px;
  overflow-y: scroll;
  height: 100vh;
  .leads-wrapper {
    width: 800px;
    .card-widget {
      width: 100%;
      margin-bottom: 10px;
      .assignments-item-header {
        padding: 10px;
        background: #fff;
        border-radius: 5px 5px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
        .assignments-item-brand {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          img {
            width: 60px;
            height: 60px;
            object-fit: contain;
            margin-right: 15px;
            border-radius: 50%;
            cursor: pointer;
          }
        }
        .contact-btn {
          width: 107px;
          height: 37px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          outline: none;
        }
        .content {
          display: flex;
          justify-content: space-between;
          width: 100%;
          .title {
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;

            .date {
              color: #808080;

              font-size: 13px;
              position: relative;
              margin-top: 8px;
            }
          }
          .options {
            .share-btn-transparent {
              background: #ffffff 0% 0% no-repeat padding-box;
              border: 1px solid #707070;
              border-radius: 5px;
              padding: 10px 18px;
              font-size: 14px;
              margin-top: 13px;
              color: #646262;
              cursor: pointer;
              outline: none;
              width: 180px;

              border: 1px solid #ccc;
            }
          }
        }
      }
      .assignments-item-body {
        padding: 20px;
        background: #fff;
        border-radius: 0px 0px 5px 5px;
        h4 {
          font-size: 20px;
          margin-bottom: 10px;
        }
        img {
          width: 100%;
        }
        p {
          font-size: 14px;
        }
        label {
          color: #808080;
          font-size: 15px;
          display: block;
          margin-bottom: 8px;
        }
        .skills-widget {
          display: flex;
          flex-wrap: wrap;
          .skill-item {
            background: #707070 0% 0% no-repeat padding-box;
            border-radius: 25px;
            color: #ffffff;
            font-size: 13px;

            padding: 5px 22px;
            margin-right: 10px;
            margin-bottom: 10px;
            display: inline-table;
          }
          &.more {
            max-height: 100% !important;
          }
        }
        .btn-more-skills {
          outline: none;
        }
        .assignments-info {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          .col-one,
          .col-two {
            width: 50%;
            label {
              color: #808080;
              margin-bottom: 3px;
              margin-top: 20px;
            }
            p {
              color: #000;
              margin: 0px;
            }
          }
        }
      }
      .assingment-option {
        display: flex;
        justify-content: flex-start;
        padding-top: 20px;
        .accept-btn {
          width: 107px;
          height: 37px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .reject-btn {
          width: 107px;
          height: 37px;
          border: 1px solid #1885ad;
          border-radius: 5px;
          color: #1885ad;
          outline: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .loader {
    height: 80px;
    margin-top: 10px;
    background: #fff;
    position: relative;
    padding: 10px 0 0 0;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    margin-bottom: 20px;
    svg {
      width: 70px !important;
    }
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .leads-widget {
    background: #efefef;
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .col-1 {
      margin-right: 20px;
      display: none;
      .card-p {
        top: 51px;
        position: sticky;
        // Button
        .leads-btn {
          background: #00a5a6 0% 0% no-repeat padding-box;
          box-shadow: 0px 1px 3px #00000029;
          border-radius: 5px;
          width: 150px;
          border: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 41px;
          padding: 11px 15px 10px 14px;
          text-decoration: none;
          height: 30px;
          margin-bottom: 20px;
          .btn-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 30px;
              margin-right: 18px;
            }
            .text {
              color: #fff;
              font-size: 14px;

              position: relative;
            }
          }
          .count {
            color: #fff;
            font-size: 14px;

            position: relative;
          }
        }
        // End of button css
        .placeholer {
          height: 300px;
          background: #fff;
          margin-bottom: 20px;
          border-radius: 5px;
        }
      }
    }

    .card-widget {
      width: 100%;
      margin-bottom: 15px;
      .search-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .search-brand {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 100px;
            margin-right: 20px;
          }
          span {
          }
        }
        .search-options {
          width: 100%;
          .input-group {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            padding: 7px 20px;
            border-radius: 5px;
            input {
              height: 35px;
              width: 100%;
              border: none;
              font-size: 14px;
            }
            input:focus {
              outline: none;
            }
            input::placeholder {
              color: #d9d9d9;
            }
            span {
              color: #d8d8d8;
              margin-right: 20px;
            }
          }
        }
      }
      .assignments-item-header {
        padding: 10px;
        background: #fff;
        border-radius: 5px 5px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
        .assignments-item-brand {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            margin-right: 15px;
          }
        }
        .content {
          display: flex;
          flex-direction: column;
          width: 100%;
          .title {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .date {
              color: #808080;

              font-size: 13px;
              left: 88px;
              position: relative;
            }
          }
          label {
            display: block;
            font-size: 14px;

            margin-bottom: 7px;
          }
          span {
            color: #808080;

            font-size: 13px;
            margin-bottom: 6px;
          }
        }
      }
      .assignments-item-body {
        padding: 20px;
        background: #fff;
        border-radius: 0px 0px 5px 5px;
        h4 {
          margin: 0px;
          margin-bottom: 10px;
        }
        img {
          width: 100%;
        }
        p {
          font-size: 14px;
        }
        label {
          color: #808080;
          font-size: 15px;
          display: block;
          margin-bottom: 8px;
        }
        .skills-widget {
          display: flex;
          flex-wrap: wrap;
          .skill-item {
            background: #707070 0% 0% no-repeat padding-box;
            border-radius: 25px;
            color: #ffffff;
            font-size: 13px;

            padding: 5px 22px;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
        .assignments-info {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          .col-one,
          .col-two {
            width: 50%;
            label {
              color: #808080;
              margin-bottom: 3px;
              margin-top: 20px;
            }
            p {
              color: #000;
              margin: 0px;
            }
          }
        }
      }
    }
  }
}
.floater {
  position: fixed;
  bottom: 0px;
  right: 20px;
  z-index: 999;
}
</style>